import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import { DynamicComponentHOC } from "components/DynamicComponentHOC/DynamicComponentHOC";
import { Message } from "components/Message/Message";
import React, { createContext, useEffect, useState } from "react";
import { OverlayTrigger, ProgressBar, Tooltip } from "react-bootstrap";
import { ComponentParams } from "types/types";
import { ICON_TYPE } from "utils/constants";
import { DYNAMICFORMS } from "utils/dynamicForms";
import {findValueByKey, trans } from "utils/helpers";
import './style.scss';


interface props {
    formList: any,
    Id: string,
    sourceId?: string,
    onHide: () => void,
    reload?: (e) => void,
    closeForm?: () => void,
    JobNo?: any
    styleCondition?: any
    RequesterPositionId?: any
    jobId?: any
    taskTitle?: any
    inDynamicForms?: any;
    disable?:boolean;
    parentMode?: any;
    useGenerate?: any;
    SourceData?: any;
    buttonPrintObjCallBack?:(any)=>void
    parentISCartable?:boolean
    refrenceId?:any
    ,
    modalFormLabelCallBack?:any
handleCallAttachment?:any
}
export const passListContext = createContext<any>([]);

export const ModalStepper: React.FC<props> = ({SourceData,refrenceId,handleCallAttachment,modalFormLabelCallBack ,parentISCartable=false, buttonPrintObjCallBack,RequesterPositionId, parentMode,inDynamicForms=false, JobNo,useGenerate=true,sourceId,formList=[], taskTitle, disable=false,styleCondition = false, Id, closeForm, onHide, reload ,jobId }) => {

    const [progress, setProgress] = useState<number>(0);
    const [counter, setCounter] = useState<any>(0);
    const [pass, setPass] = useState<any>();
    const [passList, setPassList] = useState<any>([]);
    const [stepperLabel,setStepperLabel]=useState<any>('')

    function addNewPass(e){
        if(!passList.includes(e)){
            setPassList([...passList , e])
        }
    }
    //const [references, setReferences] = useState<any>([]);
    function circleClick(e) {
        let complete = formList.length - 1
        setProgress((100 / complete) * e)
        setCounter(e)
    }



    function next() {
        let complete = formList.length - 1;
        setProgress(progress + (100 / complete))
        setCounter(counter + 1)




    }

    function prev() {
        let complete = formList.length - 1;
        setProgress(progress - (100 / complete))
        setCounter(counter - 1)

    }



    useEffect(() => {

        const formListReverc = JSON.parse(JSON.stringify(formList)) 
        let Tindex:any
        formListReverc.reverse().forEach((item, index) => {
            if (item.Parameters && item.Parameters != "") {
                let paramsObject: ComponentParams = JSON.parse(item.Parameters.toLowerCase());
                let mode = findValueByKey(paramsObject, "mode");
                if (mode != "view") {
                    Tindex = index
                }
            }
        });
        if(Tindex != undefined){
            Tindex = Math.abs((formList.length-1)-Tindex ) 
            let complete = formList.length - 1
            setProgress((100 / complete) * Tindex)
            setCounter(Tindex)
            setPass(Tindex)

        }else{
            Tindex = Math.abs(formList.length ) 
            setProgress(100 )
            setCounter(Tindex-1)
            setPass(Tindex)


        }
    }, [formList])




    return (
        <passListContext.Provider value={[passList, addNewPass]}>
        <div className="card mb-0">
            {formList?.length > 1 ?
                <div className={`align-items-start ${styleCondition ? 'referencewizard-b' : 'referencewizard'}`}>
                        <div  className=" custom-wrapper  p-2 pt-3 gy-3 align-items-start align-content-center row">
  {formList.map((item, index) => (
                                            <div className="col-6 col-md-12 h-auto" key={index}>
                                            {item.Name!="SignatureForm" &&<>
                                            {
                                                
<>
<div className="row">
    <div className="col-8 col-md-9 showDots">




  <OverlayTrigger
            key={index}
            placement="top"
            delay={{ show: 600, hide: 0 }}
            overlay={
              <Tooltip className="tooltip " id={`button-tooltip-${"reserve"}`}>
              {!DYNAMICFORMS[item?.Name] ?stepperLabel.replace("Form",""):trans(item.Name=="WarehouseIOForm"?JSON.parse(item.Parameters).Type:item.Name.replace("Form",""))}

              </Tooltip>
            }
          >
            <span className="form-check-label " onClick={() => circleClick(index)} >
{!DYNAMICFORMS[item?.Name] ?stepperLabel.replace("Form",""):trans(item.Name=="WarehouseIOForm"?JSON.parse(item.Parameters).Type:item.Name.replace("Form",""))}
  </span>
          </OverlayTrigger>






    </div>
    <div className="col-2">
  <input checked={counter==index } onClick={() => circleClick(index)} className="form-check-input" type="radio" name="radioDefault" id="radioDefault1"/>
    </div>

 
</div>
</>
                                            }</> }
                                          </div>
                                        ))}

                        </div>
                    <div className="content-card d-flex flex-column w-100">
                        <div className="content-card d-flex flex-column w-100">
                               
                            <div className={disable ? "disableWindowMode" : ''}>
                                {counter >= 0 &&
                                    <>
                                    {(formList[counter]?.forms&&formList[counter]?.forms.length>0) ?
                                            <>
                                    <DynamicComponentHOC
                                    parentISCartable={parentISCartable}
                                    modalFormLabelCallBack={(e)=>{setStepperLabel(e);modalFormLabelCallBack(e)}}
                                    buttonPrintObjCallBack={buttonPrintObjCallBack}  JobNo={JobNo} RequesterPositionId={RequesterPositionId} closeForm={closeForm} SourceData={SourceData}  sourceId={sourceId} modeParams={parentMode} inDynamicForms={inDynamicForms} taskTitle={taskTitle} onHide={onHide} 
                                    componentName={DYNAMICFORMS[formList[counter].Name] ?null:formList[counter].Name} component={DYNAMICFORMS[formList[counter].Name] ?DYNAMICFORMS[formList[counter].Name].component:null}
                                        reload={reload} componentParams={formList[counter].Parameters} processId={formList[counter].ProjectId}
                                        TaskId={formList[counter].TaskId} useGenerate={useGenerate}
                                        referenceId={Id} jobId={jobId} handleCancelForm={() => onHide()} 
                                        handleCallAttachment={handleCallAttachment}
                                        
                                        />

                                    <DynamicComponentHOC 
                                     parentISCartable={parentISCartable}
                                     buttonPrintObjCallBack={buttonPrintObjCallBack}
                                     modalFormLabelCallBack={(e)=>{setStepperLabel(e);modalFormLabelCallBack(e)}}
                                    JobNo={JobNo} RequesterPositionId={RequesterPositionId} closeForm={closeForm} SourceData={SourceData}  sourceId={sourceId} modeParams={parentMode} inDynamicForms={inDynamicForms} taskTitle={taskTitle} onHide={onHide} 
                                    componentName={DYNAMICFORMS[formList[counter]?.forms[0].Name] ?null:formList[counter]?.forms[0].Name} component={DYNAMICFORMS[formList[counter]?.forms[0].Name] ?DYNAMICFORMS[formList[counter]?.forms[0].Name].component:null}
                                        reload={reload} componentParams={formList[counter]?.forms[0].Parameters} processId={formList[counter]?.forms[0].ProjectId}
                                        TaskId={formList[counter]?.forms[0].TaskId} useGenerate={useGenerate}
                                        referenceId={Id} jobId={jobId} handleCancelForm={() => onHide()}
                                        handleCallAttachment={handleCallAttachment}
                                        />
                                            </>
                                    :
                                    <DynamicComponentHOC 
                                    parentISCartable={parentISCartable}
                                    modalFormLabelCallBack={(e)=>{setStepperLabel(e);modalFormLabelCallBack(e)}}
                                    buttonPrintObjCallBack={buttonPrintObjCallBack} JobNo={JobNo} RequesterPositionId={RequesterPositionId} closeForm={closeForm} SourceData={SourceData}  sourceId={sourceId} modeParams={parentMode} inDynamicForms={inDynamicForms} taskTitle={taskTitle} onHide={onHide} 
                                    componentName={DYNAMICFORMS[formList[counter].Name] ?null:formList[counter].Name} component={DYNAMICFORMS[formList[counter].Name] ?DYNAMICFORMS[formList[counter].Name].component:null}
                                        reload={reload} componentParams={formList[counter].Parameters} processId={formList[counter].ProjectId}
                                        TaskId={formList[counter].TaskId} useGenerate={useGenerate}
                                        referenceId={Id} jobId={jobId} handleCancelForm={() => onHide()} 
                                        
                                        handleCallAttachment={handleCallAttachment}
                                        />

                                    }

                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                    :
                    <>
                    {formList && formList[0] ?
                        <div className={disable ? "disableWindowMode" : ''}>

                        {(formList[0]?.forms&&formList[0]?.forms.length>0) ?<>
    
                            <DynamicComponentHOC
                            buttonPrintObjCallBack={buttonPrintObjCallBack}
                                    parentISCartable={parentISCartable}
                                    modalFormLabelCallBack={(e)=>{setStepperLabel(e);modalFormLabelCallBack(e)}}
                                   JobNo={JobNo} RequesterPositionId={RequesterPositionId} closeForm={closeForm} SourceData={SourceData} sourceId={sourceId} modeParams={parentMode} inDynamicForms={inDynamicForms} taskTitle={taskTitle} onHide={onHide} 
                                    componentName={DYNAMICFORMS[formList[0].Name] ?null:formList[0].Name} component={DYNAMICFORMS[formList[0].Name] ?DYNAMICFORMS[formList[0].Name].component:null}
                                    reload={reload}  Name={formList[0].Name}  componentParams={formList[0].Parameters} processId={formList[0].ProjectId} TaskId={formList[0].TaskId}
                                    referenceId={Id} useGenerate={useGenerate} jobId={jobId} handleCancelForm={() => onHide()}  
                                    handleCallAttachment={handleCallAttachment}
                                    />
                            <DynamicComponentHOC
                            modalFormLabelCallBack={(e)=>{setStepperLabel(e);modalFormLabelCallBack(e)}}
                             parentISCartable={parentISCartable}
                             buttonPrintObjCallBack={buttonPrintObjCallBack}
                            JobNo={JobNo} RequesterPositionId={RequesterPositionId} closeForm={closeForm} SourceData={SourceData} sourceId={sourceId} modeParams={parentMode} inDynamicForms={inDynamicForms} taskTitle={taskTitle} onHide={onHide} 
                                componentName={DYNAMICFORMS[formList[0]?.forms[0].Name] ?null:formList[0]?.forms[0].Name} component={DYNAMICFORMS[formList[0]?.forms[0].Name] ?DYNAMICFORMS[formList[0]?.forms[0].Name].component:null}
                                reload={reload}  Name={formList[0]?.forms[0].Name}  componentParams={formList[0]?.forms[0].Parameters} processId={formList[0]?.forms[0].ProjectId} TaskId={formList[0]?.forms[0].TaskId}
                                referenceId={Id} useGenerate={useGenerate} jobId={jobId} handleCancelForm={() => onHide()}
                                handleCallAttachment={handleCallAttachment}
                                />
                                        </>
                                :
                                <DynamicComponentHOC
                                buttonPrintObjCallBack={buttonPrintObjCallBack}
                                modalFormLabelCallBack={(e)=>{setStepperLabel(e);modalFormLabelCallBack(e)}}
                                parentISCartable={parentISCartable}
                                JobNo={JobNo} RequesterPositionId={RequesterPositionId} closeForm={closeForm} SourceData={SourceData} sourceId={sourceId} modeParams={parentMode} inDynamicForms={inDynamicForms} taskTitle={taskTitle} onHide={onHide} 
                                componentName={DYNAMICFORMS[formList[0].Name] ?null:formList[0].Name} component={DYNAMICFORMS[formList[0].Name] ?DYNAMICFORMS[formList[0].Name].component:null}
                                reload={reload}  Name={formList[0].Name}  componentParams={formList[0].Parameters} processId={formList[0].ProjectId} TaskId={formList[0].TaskId}
                                referenceId={Id} useGenerate={useGenerate} jobId={jobId} handleCancelForm={() => onHide()} 
                                handleCallAttachment={handleCallAttachment}
                                />
}
                        </div>
                        :
                        <Message message={"Msg_NoFormDefinedForTask"} type={"info"} />

                    }
                </>


            }



        </div>
        </passListContext.Provider>

    )
}



















